import React, { useEffect, useState } from "react";
import { httpClient } from '../../HttpClient';

function EditTodoForm({
  formData,
  editLoading,
  isSubmitting,
  handleFormChange,
  handleUserIdsChange,
  handleFormSubmit,
  onCancel,
}) {
  const [allUsers, setAllUsers] = useState([]);
  const [userMap, setUserMap] = useState({});
  const [selectedUserId, setSelectedUserId] = useState("");

  useEffect(() => {
    httpClient
      .get("https://backend-myalfa.vercel.app/api/users")
      .then((res) => {
        setAllUsers(res.data);
        const map = {};
        res.data.forEach((user) => {
          map[user.id] = user;
        });
        setUserMap(map);
      })
      .catch((err) => {
        console.error("Erreur chargement utilisateurs", err);
      });
  }, []);

  const handleAddUser = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedUserId(""); // reset l'affichage du select
    if (!formData.userIds.includes(selectedId)) {
      const updatedIds = [...formData.userIds, selectedId];
      handleUserIdsChange({ target: { value: updatedIds.join(",") } });
    }
  };

  const handleRemoveUser = (idToRemove) => {
    const updatedIds = formData.userIds.filter((id) => id !== idToRemove);
    handleUserIdsChange({ target: { value: updatedIds.join(",") } });
  };

  if (editLoading) {
    return <p className="loading-text">Chargement des données du todo...</p>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "80%" }}>
      <h3>Assigner la Mission</h3>
      <form className="FormMission" onSubmit={handleFormSubmit}>
        <label>Titre :</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleFormChange}
        />
        <br />
        <label>Statut :</label>
        <input
          type="text"
          name="status"
          value={formData.status}
          onChange={handleFormChange}
        />
        <br />
        <label>Échéance (dueDate) :</label>
        <input
          type="datetime-local"
          name="dueDate"
          value={
            formData.dueDate
              ? new Date(formData.dueDate).toISOString().slice(0, 16)
              : ""
          }
          onChange={handleFormChange}
        />
        <br />
        <label>Priorité :</label>
        <input
          type="text"
          name="priority"
          value={formData.priority || ""}
          onChange={handleFormChange}
        />
        <br />
        <label>Description :</label>
        <textarea
          name="commentaire"
          value={formData.commentaire || ""}
          onChange={handleFormChange}
        />
        <br />
        <label>Utilisateurs assignés :</label>
        <ul>
          {formData.userIds.map((id) => {
            const user = userMap[id];
            return (
              <li key={id}>
                {user
                  ? `${user.lastName} ${user.name} (ID: ${id})`
                  : `ID: ${id}`}
                <button type="button" onClick={() => handleRemoveUser(id)}>
                  Supprimer
                </button>
              </li>
            );
          })}
        </ul>

        <label>Ajouter un utilisateur :</label>
        <select onChange={handleAddUser} value={selectedUserId}>
          <option value="" disabled>
            Sélectionner un utilisateur
          </option>
          {allUsers
            .filter((user) => !formData.userIds.includes(user.id))
            .map((user) => (
              <option key={user.id} value={user.id}>
                {user.lastName} {user.name} (ID: {user.id})
              </option>
            ))}
        </select>

        <div className="form-buttons">
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "en cours d'enregistrement ..." : "Enregistrer"}
          </button>

          <button type="button" onClick={onCancel}>
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditTodoForm;
